import { render, staticRenderFns } from "./indexShipment.vue?vue&type=template&id=280a0dea&scoped=true"
import script from "./indexShipment.vue?vue&type=script&lang=js"
export * from "./indexShipment.vue?vue&type=script&lang=js"
import style0 from "./indexShipment.vue?vue&type=style&index=0&id=280a0dea&prod&lang=scss"
import style1 from "./indexShipment.vue?vue&type=style&index=1&id=280a0dea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280a0dea",
  null
  
)

export default component.exports